export default __webpack_public_path__ + "static/media/radio.ba38f663.svg";